import React from 'react';

const LoadingComponent = () => {

    return (
        <div className="empty">
            <p>A carregar...</p>
        </div>
    );
};

export default LoadingComponent;